import { render, staticRenderFns } from "./GuestWizardNewLinkedDocumentEditView.vue?vue&type=template&id=28627a18&"
import script from "./GuestWizardNewLinkedDocumentEditView.vue?vue&type=script&lang=ts&"
export * from "./GuestWizardNewLinkedDocumentEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports